// src/pages/Admin/UsersCategoryEdit.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import TitleWithBack from '../../components/common/TitleWithBack';

function UsersCategoryEdit() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [category, setCategory] = useState({ name: '', description: '' });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [tooltip, setTooltip] = useState('');

  useEffect(() => {
    axios.get(`/api/user-categories/${id}`)
      .then((response) => {
        setCategory(response.data);
        setLoading(false);
      })
      .catch(() => {
        setError('Error fetching category data.');
        setLoading(false);
      });
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCategory(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    axios.put(`/api/user-categories/${id}`, category)
      .then(() => {
        setTooltip('Category updated successfully.');
        setTimeout(() => navigate('/admin/users/category/view'), 2000);
      })
      .catch(() => {
        setError('Error updating category.');
      });
  };

  if (loading) return <div className="container mt-4"><p>Loading category data...</p></div>;
  if (error) return <div className="container mt-4"><p className="text-danger">{error}</p></div>;

  return (
    <div className="container mt-2">
      <TitleWithBack title="Edit User Category" />
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label">Category Name:</label>
          <input
            type="text"
            name="name"
            className="form-control"
            value={category.name}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Description:</label>
          <textarea
            name="description"
            className="form-control"
            value={category.description}
            onChange={handleChange}
            required
          />
        </div>
        <button type="submit" className="btn btn-primary">Update Category</button>
      </form>
      {tooltip && (
        <div className="mt-3 alert alert-info">{tooltip}</div>
      )}
    </div>
  );
}

export default UsersCategoryEdit;
